import { useState } from 'react';
import useResize from '../useResize';

const userRerenderOnResize = () => {
  const [wasRerender, forceUpdate] = useState({});
  useResize(() => forceUpdate({}));

  return wasRerender;
};

export default userRerenderOnResize;
